import React, { useEffect, useMemo, useState, useRef, Fragment } from 'react'
import { Option } from 'react-select/src/filters'

import styled from 'styled-components'
import { UserRoleTypeWithStatus } from 'pages/UserRole/model/role'

import Checkbox from 'shared/components/Checkbox'
import SelectAutocomplete from 'shared/components/SelectAutocomplete'
import Box from 'shared/components/Box'

type SelectUserGroupProps = {
  roles: UserRoleTypeWithStatus[]
  roleIds: string[]
  onChange: (key: string, value: any) => void
  removeOrAddToUserRoleList: (checked: boolean, method: string) => any
}

function SelectUserGroup(props: SelectUserGroupProps) {
  const { roles, roleIds, onChange, removeOrAddToUserRoleList } = props
  const [isOpen, toggleSelector] = useState(false)
  const ref: any = useRef(null)

  useEffect(() => {
    function handleClickOutside(event: Event) {
      const options = document.querySelector(`.select-field__menu`)
      const target = event?.target as Node

      if (isOpen && !options?.contains(target))
        toggleSelector(false)

      if (!isOpen && ref?.current?.contains(event?.target))
        toggleSelector(true)
    }

    document.addEventListener("mousedown", handleClickOutside)
    document.addEventListener("touchend", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
      document.removeEventListener("touchend", handleClickOutside)
    }
  }, [ref, isOpen])

  const options = useMemo(() => (
    roles.map(each => ({
      label: each?.display_name || each?.name,
      value: each?.id,
      checked: roleIds?.includes(each?.id)
    }))
  ), [roles, roleIds])

  const label = useMemo(() => {
    const selected = roleIds.map((id: string) => {
      return roles?.find((role: UserRoleTypeWithStatus) => role?.id === id)?.name
    })

    return (selected?.length > 4)
      ? `Selected ${selected?.length} User Group`
      : selected?.join(', ')
  }, [roles, roleIds])

  return (
    <SelectUserGroupContainer ref={ref}>
      <SelectAutocomplete
        isLoading={false}
        isSearchable={false}
        menuIsOpen={isOpen}
        value=""
        id="user-group"
        options={options}
        components={{
          Option: React.memo(OptionUserGroup),
        }}
        onChange={() => {}}
        onInputChange={() => {}}
        error=""
        label=""
        className=""
        placeholder=""
        menuPortalTarget={document.body}
      />
      <SelectLabelContainer>
        <SelectLabel>{label || 'Select User Group'}</SelectLabel>
      </SelectLabelContainer>
    </SelectUserGroupContainer>
  )

  function OptionUserGroup(option: Option) {
    const { data } = option
    return (
      <OptionUserGroupContainer
        onClick={() => {
          onChange('role_ids', removeOrAddToUserRoleList(Boolean(!data.checked), data?.value))
        }}
      >
        <Checkbox
          name={data?.label}
          id={data?.id}
          checked={Boolean(data.checked)}
          label={data?.label}
        />
      </OptionUserGroupContainer>
    )
  }
}

const SelectLabel = styled(Box)`
  font-size: 18px;
  color: #353535;
`
const SelectLabelContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 20px;
  width: auto;
  transform: translateY(-50%);
`

const SelectUserGroupContainer = styled(Box)`
  .select-field__menu-list {
    padding-bottom: 12px;
    padding-top: 12px;
  }

  .select-field__menu {
    z-index: 2;
  }
`

const OptionUserGroupContainer = styled(Box)`
  padding: 4px 16px;
  // border: 1px solid red;

  label {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
  }

  .md-selection-control-container {
    // border: 1px solid green;
    display: flex;
    align-items: center;
  }
`

export default SelectUserGroup
